export default {
  minio_server:"http://47.104.62.144:9000",
  geo_server:"http://47.104.62.144:8080"
}



// WEBPACK FOOTER //
// ./src/view/BSD/AppConfig.js